import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ltx/phase-i/consultations/pulmonaryFunctionTest";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	pulmonaryFunctionTest: {
		id: "form.pulmonary_function_test",
		defaultMessage: "Légzésfunkciós vizsgálat"
	},
	fev1: {
		id: "form.pulmonary_function_test.fev1",
		defaultMessage: "FEV1"
	},
	fvc: {
		id: "form.pulmonary_function_test.fvc",
		defaultMessage: "FVC"
	},
	pef: {
		id: "form.pulmonary_function_test.pef",
		defaultMessage: "PEF"
	},
	mef75: {
		id: "form.pulmonary_function_test.mef75",
		defaultMessage: "MEF75"
	}
});

const fields: { [key: string]: FieldData } = {
	fev1: {
		type: "field",
		path: ["fev1"],
		label: messages.fev1,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	fvc: {
		type: "field",
		path: ["fvc"],
		label: messages.fvc,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	pef: {
		type: "field",
		path: ["pef"],
		label: messages.pef,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	mef75: {
		type: "field",
		path: ["mef75"],
		label: messages.mef75,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.fev1 },
				{ width: 6, field: fields.fvc }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.pef },
				{ width: 6, field: fields.mef75 }
			]
		}
	]
};

export const node: LeafNode = {
	id: "pulmonaryFunctionTest",
	value: {
		title: messages.pulmonaryFunctionTest,
		validator,
		fieldset
	}
};
